import { render } from "./Companies.vue?vue&type=template&id=0121c85c&scoped=true"
import script from "./Companies.vue?vue&type=script&lang=js"
export * from "./Companies.vue?vue&type=script&lang=js"

import "./Companies.vue?vue&type=style&index=0&id=0121c85c&lang=scss&scoped=true"

import exportComponent from "/Users/umar/Desktop/umi-portfolio-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0121c85c"]])

export default __exports__